export default {
    path: 'without_card',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/pay_manage/withoutCard'),
    meta: {title:'无卡发薪'},
	children: [
	]
}